import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Style
import { Button, Col, Collapse } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SideBar.css';
import FontAwesome from 'react-icons/fa';

// Component
import Link from '../../Link';

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step1: true,
      step3: false,
      home: false,
    };
  }

  render() {
    const { step1, step3, home } = this.state;
    return (
      <div className={cx(s.sidebarWrapper, 'hidden-print')}>
        <div className={cx(s.sideBarWelcome)}>
          <span>Welcome, Admin</span>
        </div>
        <ul className={s.sidebarNav}>
          <li>
            <Link to={'/siteadmin/'}>
              <i className={`${s.navigationIcon} fa fa-bar-chart`} />
              <span>Dashboard</span>
            </Link>
          </li>

          <li>
            <Link to={'/siteadmin/settings/site'}>
              <i className={`${s.navigationIcon} fa fa-cog`} />
              <span>Site Settings</span>
            </Link>
          </li>

          <li>
            <Link to={'/siteadmin/users'}>
              <i className={`${s.navigationIcon} fa fa-user`} />
              <span>Manage Users</span>
            </Link>
          </li>

          <li>
            <Link to={'/siteadmin/reservations'}>
              <i className={`${s.navigationIcon} fa fa-plane`} />
              <span>Manage Payouts</span>
            </Link>
          </li>

          <li>
            <Button
              bsStyle="link"
              className={cx(s.button, s.noPadding)}
              onClick={() =>
                this.setState({
                  adminReview: !this.state.adminReview,
                })
              }
            >
              <i className={`${s.navigationIcon} fa fa-star`} />
              <span>Admin Reviews</span>
              {this.state.adminReview && (
                <i className={`${s.navigationIcon} fa fa-angle-up`} />
              )}

              {!this.state.adminReview && (
                <i className={`${s.navigationIcon} fa fa-angle-down`} />
              )}
            </Button>
            <Collapse in={this.state.adminReview} className={s.subMenu}>
              <div>
                <Link to={'/siteadmin/reviews'}>
                  <i className={`${s.navigationIcon} fa fa-circle-thin`} />
                  <span>Manage Reviews</span>
                </Link>

                <Link to={'/siteadmin/write-reviews'}>
                  <i className={`${s.navigationIcon} fa fa-circle-thin`} />
                  <span>Write Review</span>
                </Link>
              </div>
            </Collapse>
          </li>

          <li>
            <Link to={'/siteadmin/document'}>
              <i className={`${s.navigationIcon} fa fa-file`} />
              <span>Document Verification</span>
            </Link>
          </li>

          <li>
            <Link to={'/siteadmin/messages'}>
              <i className={`${s.navigationIcon} fa fa-inbox`} />
              <span>Messages</span>
            </Link>
          </li>
          {
            // <li>
            //   <Link to={'/siteadmin/reportUser'}>
            //     <i className={`${s.navigationIcon} fa fa-user-secret`} />
            //     <span>Report Management</span>
            //   </Link>
            // </li>
          }

          <li>
            <Link to={'/siteadmin/change/admin'}>
              <i className={`${s.navigationIcon} fa fa-cogs`} />
              <span>Change Admin Password</span>
            </Link>
          </li>

          <li>
            <Link to={'/siteadmin/bulklistings'}>
              <i className={`${s.navigationIcon} fa fa-cogs`} />
              <span>Bulk Listings Tool</span>
            </Link>
          </li>

          <li>
            <Button
              bsStyle="link"
              className={cx(s.button, s.noPadding)}
              onClick={() =>
                this.setState({
                  home: !this.state.home,
                })
              }
            >
              <i className={`${s.navigationIcon} fa fa-home`} />
              <span>Home Page Settings</span>
              {this.state.home && (
                <i className={`${s.navigationIcon} fa fa-angle-up`} />
              )}

              {!this.state.home && (
                <i className={`${s.navigationIcon} fa fa-angle-down`} />
              )}
            </Button>
            <Collapse in={this.state.home} className={s.subMenu}>
              <div>
                <Link to={'/siteadmin/home/caption'}>
                  <i className={`${s.navigationIcon} fa fa-circle-thin`} />
                  <span>Banner Caption</span>
                </Link>

                <Link to={'/siteadmin/home/banner'}>
                  <i className={`${s.navigationIcon} fa fa-circle-thin`} />
                  <span>Image Banner</span>
                </Link>

                <Link to={'/siteadmin/home/footer-block'}>
                  <i className={`${s.navigationIcon} fa fa-circle-thin`} />
                  <span>Footer Block</span>
                </Link>
              </div>
            </Collapse>
          </li>

          <li>
            <Button
              bsStyle="link"
              className={cx(s.button, s.noPadding)}
              onClick={() =>
                this.setState({
                  step1: !this.state.step1,
                })
              }
            >
              <i className={`${s.navigationIcon} fa fa-sliders`} />
              <span>Categories</span>
              {this.state.step1 && (
                <i className={`${s.navigationIcon} fa fa-angle-up`} />
              )}

              {!this.state.step1 && (
                <i className={`${s.navigationIcon} fa fa-angle-down`} />
              )}
            </Button>
            <Collapse in={this.state.step1} className={s.subMenu}>
              <div>
                <Link to={'/siteadmin/listsettings/1'}>
                  <i className={`${s.navigationIcon} fa fa-circle-thin`} />
                  <span>Categories</span>
                </Link>
                {/* <Link to={'/siteadmin/listsettings/2'}>

                                        <i className={s.navigationIcon + ' fa fa-circle-thin'} />
                                        <span>Person Capacity</span>
                                </Link> */}
                {/* <Link to={'/siteadmin/listsettings/3'}>
                            <i className={s.navigationIcon + ' fa fa-circle-thin'} />
                            <span>House Type</span>
                          </Link>
                            */}
                {/* <Link to={'/siteadmin/listsettings/4'}>

                                  <i className={s.navigationIcon + ' fa fa-circle-thin'} />
                                  <span>Building Size</span>
                            </Link> */}
                {/* <Link to={'/siteadmin/listsettings/5'}>
                                <i className={s.navigationIcon + ' fa fa-circle-thin'} />
                                <span>Bed Rooms</span>
                        </Link> */}
                {/* <Link to={'/siteadmin/listsettings/6'}>

                                <i className={s.navigationIcon + ' fa fa-circle-thin'} />
                                <span>Beds</span>
                              < /Link> */}{' '}
                {/*
                            <Link to={'/siteadmin/listsettings/7'}>
                                <i className={s.navigationIcon + ' fa fa-circle-thin'} />
                                <span>Bed Type</span>
                              < /Link> */}{' '}
                {/*

                            <Link to={'/siteadmin/listsettings/8'}>
                                <i className={s.navigationIcon + ' fa fa-circle-thin'} />
                                <span>Bathrooms</span>
                              < /Link> */}{' '}
                {/*

                            <Link to={'/siteadmin/listsettings/9'}>
                                <i className={s.navigationIcon + ' fa fa-circle-thin'} />
                                <span>Bathroom Type</span>
                              < /Link>
                <Link to={'/siteadmin/listsettings/10'}>
                  <i className={s.navigationIcon + ' fa fa-circle-thin'} />
                  <span>Features</span>
                </Link>


                            <Link to={'/siteadmin/listsettings/11'}>
                                <i className={s.navigationIcon + ' fa fa-circle-thin'} />
                                <span>Safety Amenities</span>
                              < /Link>
                <Link to={'/siteadmin/listsettings/12'}>
                  <i className={s.navigationIcon + ' fa fa-circle-thin'} />
                  <span>Categories</span>
                </Link> */}
              </div>
            </Collapse>
          </li>
        </ul>
      </div>
    );
  }
}

export default withStyles(s)(SideBar);



// WEBPACK FOOTER //
// ./src/components/siteadmin/SideBar/SideBar.js